<div class="multi-dropbox">
    <label>
        {{ placeholderLabel }}
    </label>
    <mat-form-field floatLabel="never" [appearance]="appearance" [ngClass]="cssClassToApply">
        <mat-select [placeholder]="placeholder" (openedChange)="onOpenedChange($event)" [multiple]="allowMultiple" [(ngModel)]="value" disableOptionCentering="true" [compareWith]="compareDropboxData" (ngModelChange)="applySelectionChanges($event)">
            <ngx-mat-select-search [formControl]="filterControl" [placeholderLabel]="placeholderLabel" [noEntriesFoundLabel]="noEntriesFoundLabel"></ngx-mat-select-search>
            <i [class]="iconClass" [hidden]="filterControl?.value">search</i>
            <div class="options-container">
                <mat-option [ngClass]="classForOptions" *ngFor="let item of filteredItems" [value]="item">
                    {{item.name | marketFormat}}
                    <app-badge-station *ngIf="showStationBadge && item.mergedStation" [mergedStation]="item.mergedStation"></app-badge-station>
                    <button mat-icon-button (click)="editClicked(item)" [hidden]="!enableEdit" style="float: right;">
                        <mat-icon matSuffix style="right: -14px; position: relative;">edit</mat-icon>
                    </button>
                </mat-option>
            </div>
            <div class="dropbox-footer" [hidden]="hideFilterButton || !allowMultiple">
                <button [hidden]="hideSelectAll" mat-button class="float-left" (click)="selectAll()" [disabled]="!(filterControl.value && (filterControl.value.length > 0) && (filteredItems?.length > 0))">SELECT ALL</button>
                <button [hidden]="hideSelectNone" mat-button class="float-left" (click)="selectNone()" [disabled]="!(filterControl.value && (filterControl.value.length > 0) && (filteredItems?.length > 0))">SELECT NONE</button>
                <button mat-button class="clear-filters float-right" (click)="onFilter()" [disabled]="!(value && (value.length > 0))">OK</button>
            </div>
            <mat-select-trigger>
                <div *ngIf="selectedFirstValue" class="selected-label-box">
                    <div class="selected-label-text">
                        {{ selectedFirstValue.name }}
                    </div>
                    <div *ngIf="showStationBadge && selectedFirstValue.mergedStation" class="selected-label-badge">
                        <app-badge-station [changeClass]="true" [mergedStation]="selectedFirstValue.mergedStation"></app-badge-station>
                    </div>
                    <div class="selected-label-additional-selection" *ngIf="value.length > 1">
                        &nbsp;(+{{ value.length - 1 }})&nbsp;
                    </div>
                </div>
            </mat-select-trigger>
        </mat-select>
    </mat-form-field>
</div>
